var RegisterPageEnum = /* @__PURE__ */ ((RegisterPageEnum2) => {
  RegisterPageEnum2["REGISTER_PAGE_INPUT_CPF"] = "register-page--input-cpf";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_LEGAL_NAME"] = "register-page--input-legal-name";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_SOCIAL_NAME"] = "register-page--input-social-name";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_BIRTHDATE"] = "register-page--input-birthdate";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_CELLPHONE"] = "register-page--input-cellphone";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_EMAIL"] = "register-page--input-email";
  RegisterPageEnum2["REGISTER_PAGE_INPUT_PASSWORD"] = "register-page--input-password";
  RegisterPageEnum2["REGISTER_PAGE_GENDER_FEMALE_RADIO"] = "register-page--gender-female-radio";
  RegisterPageEnum2["REGISTER_PAGE_GENDER_MALE_RADIO"] = "register-page--gender-male-radio";
  RegisterPageEnum2["REGISTER_PAGE_GENDER_NONBINARY_RADIO"] = "register-page--gender-nonbinary-radio";
  RegisterPageEnum2["REGISTER_PAGE_GENDER_NOT_INFORMED_RADIO"] = "register-page--gender-not-informed-radio";
  RegisterPageEnum2["REGISTER_PAGE_SUBMIT_BUTTON"] = "button-submit--register-page-form";
  return RegisterPageEnum2;
})(RegisterPageEnum || {});
export {
  RegisterPageEnum
};
